<template>
  <div id="app">
    <!-- 登出按鈕 -->
    <div style="position: fixed; left: 20px; top: 20px;">
      <el-button type="info" @click="logout">{{ $t('Store.logout') }}</el-button>
      <el-button type="info" plain @click="gotoHistory">{{ $t('Store.record') }}</el-button>
    </div>
    <!-- 結帳頁面 -->
    <div style="margin-top: 35px;">
      <!-- 標題 -->
      <h2 style="color: #555; font-weight: 500;">
        <span style="font-weight: 700; color: #333; font-family: 'Poppins', sans-serif;"><span style="color: #666;">{{ page.pageName }}</span> {{ storeid }}</span>
      </h2>
      <!-- 浮水印 -->
      <a href="https://www.eilis-ai.com/" class="web">{{ $t('Store.powerby') }}</a>
      <!-- 輸入欄 -->
      <div class="grid-content bg-purple-light" style="margin-top: 10px;">
        <!-- EILIS ID -->
        <el-input :placeholder="$t('Store.scan') + $t('Store.userid')"
          @change="getValue"
          v-model="user.eilisid"
          @focus="getFocus('userid')">
          <template slot="prepend">{{ $t('Store.userid') }}</template>
        </el-input>
        <!-- 用戶電話 -->
        <el-row :gutter="5" style="margin-bottom: 15px;">
          <el-col :span="18">
            <el-input :placeholder="$t('Store.please_input') + $t('Store.phone')"
              style="color: black; overflow: hidden; width: 100%;"
              v-model="user.truephone"
              @focus="getFocus('phone')">
              <template slot="prepend">{{ $t('Store.phone') }}</template>
            </el-input>
            <div style="margin-top: -20px;">{{ $t('Store.no_register') }} <span style="color: #f24; text-decoration: underline; cursor: pointer;" @click="showTutorial">{{ $t('Store.query_tutorial') }}</span></div>
          </el-col>
          <el-col :span="6">
            <el-button :disabled="user.truephone === ''" @click="getValue" type="primary" style="width: 100%; margin-left: 0px !important;">{{ $t('Store.search') }}</el-button>
          </el-col>
        </el-row>
        <!-- 點數 -->
        <div style="font-size: 15px;">
          <el-row :gutter="5">
            <el-col :span="18">
              <div style="border: 1px solid #b0b0b0; border-radius: 4px; padding: 15px;">
                <el-row style="margin: 0 !important;">
                  <el-col :span="12">
                    <div style="font-weight: 500; margin-bottom: 10px;">{{ $t('Store.user_name') }}: <span style="color: #409EFF; font-weight: 600;">{{ user.name }}</span></div>
                    <div style="font-weight: 500;">{{ $t('Store.user_point') }}: <span style="color: #409EFF; font-weight: 600;">{{ user.points }}</span></div>
                  </el-col>
                  <el-col :span="12">
                    <div style="font-weight: 500; margin-bottom: 10px;">{{ $t('Store.user_exp') }}: <span style="color: #409EFF; font-weight: 600;">{{ user.exp }}</span></div>
                    <div style="font-weight: 500;">{{ $t('Store.user_level') }}: <span style="color: #409EFF; font-weight: 600;">{{ user.level}}</span></div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-button style="width: 100%; margin-left: 0px !important; margin-bottom: 6px;" type="danger" :disabled="!user.points" @click="checkPoint('point')">{{ $t('Store.redeem') }}</el-button>
                <el-button style="width: 100%; margin-left: 0px !important;" type="info" :disabled="!user.points && user.points !== 0" @click="checkPoint('send')">{{ $t('Store.topup') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 消費金額 -->
        <el-input :placeholder="$t('Store.please_input') + $t('Store.totalprice')"
          v-model="price" 
          @focus="getFocus('price');">
          <template slot="prepend">{{ $t('Store.totalprice') }}</template>
        </el-input>
        <!-- 無效金額 -->
        <mu-dialog :title="$t('Store.system')" width="600" :open="validprice" @close="validprice = false">
          {{ $t('Store.invalid_price') }}
        </mu-dialog>
        <!-- 再次確認 -->
        <mu-dialog :title="$t('Store.system')" width="500" :open="checkDia">
          {{ $t('Store.comfirm_comsume') }}: <br>
          {{ $t('Store.user_phone') }}: {{ user.truephone }} <br>
          {{ $t('Store.amount') }}: {{ price }} <br>
          <div class="recommend" v-if="page.recommend">
            <div>
              <mu-switch v-model="page.isrecommend" label="輸入推薦人"></mu-switch>
            </div>
            <div style="margin-top: 10px;" v-if="page.isrecommend">
              <el-row :gutter="10" style="margin-bottom: 0;">
                <el-col :span="16">
                  <el-input placeholder="請輸入電話" v-model="recommendDetail.recommendData.phone">
                    <template slot="prepend">推薦人電話</template>
                  </el-input>
                </el-col>
                <el-col :span="8">
                  <el-button type="primary" style="width: 45%" @click="getRecommend" :disabled="recommendDetail.recommendData.phone === ''">{{ $t('Store.search') }}</el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <el-input disabled v-model="recommendDetail.recommendData.exp">
                    <template slot="prepend">當前積分</template>
                  </el-input>
                  <span v-if="unabledRecommend" style="color: #f24;">輸入的電話無效，請注意推薦電話不能重複使用!</span>
                </el-col>
              </el-row>
            </div>
          </div>
          <mu-button slot="actions" flat color="primary" @click="checkDia = false">{{ $t('Store.back') }}</mu-button>
          <mu-button slot="actions" flat color="primary" @click="checkComsume">{{ $t('Store.check') }}</mu-button>
          <mu-dialog :open="recommendLoading" width="250">
            <mu-linear-progress></mu-linear-progress>
          </mu-dialog>
        </mu-dialog>
        <!-- 教學圖片 -->
        <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="tutorialDia">
          <mu-appbar color="primary" title="查詢用戶電話教學">
            <mu-button slot="left" icon @click="tutorialDia = false">
              <mu-icon value="close"></mu-icon>
            </mu-button>
          </mu-appbar>
          <div style="padding: 24px;">
            <img src="https://i.imgur.com/ndy7iPa.jpg" width="75%"/>
          </div>
        </mu-dialog>
        <!-- 成功訊息 -->
        <mu-dialog :title="$t('Store.success')" width="600" :open="completeDia" @close="completeDia = false">
          {{ $t('Store.update_succeed') }}<br>
          {{ $t('Store.phone') }}: {{ user.truephone }}<br>
          {{ $t('Store.remain_point') }}: {{ user.newpoint }}
        </mu-dialog>
        <!-- 兌換點數專區 -->
        <mu-dialog :title="$t(dialogTitle)" width="650" :open="confirmDia">
          <!-- 退出鍵 -->
          <div style="position: absolute; right: 20px; top: -60px;">
            <el-button type="danger" circle icon="el-icon-close" @click="confirmDia = false; type = ''; exchangePoints = ''"></el-button>
          </div>
          <!-- 輸入框 -->
          <el-input v-model="exchangePoints"
            :placeholder="$t('Store.please_input') + $t('Store.point')"
            @focus="checkPoint(type)">
            <template slot="prepend">{{ $t('Store.point') }}</template>
          </el-input>
          <!-- 錯誤提示 -->
          <div style="color: #f24; margin-top: -10px;">{{ $t(hintText) }}</div>
          <!-- 鍵盤區 -->
          <keyboard @addNum="inputNumber" @clear="clear"/>
          <el-button style="width: 100%; margin-top: 15px;" type="success" @click="sendExchange">{{ $t('Store.send') }}</el-button>
        </mu-dialog>
        <!-- 兌換點數專區 -->
      </div>
      <!-- 錯誤訊息 -->
      <mu-dialog :title="$t('Store.system')" width="500" :open.sync="showWarn">
        {{warning}}
      </mu-dialog>
      <!-- 鍵盤區 -->
      <keyboard @addNum="inputNumber" @clear="clear"/>
      <!-- 確認送出 -->
      <el-row style="width: 630px; margin: 15px auto;" :gutter="5">
        <el-col :span="24">
          <el-button v-if="!page1"
            :disabled="!user.hasLINE && !user.hasFB"
            style="width: 100%; margin-left: 0px !important;"
            type="success"
            @click="checksend">
            {{ $t('Store.paid') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';
import keyboard       from '../shop/page/keyboard';

const defaultUser = {
  fbtoken: '',
  linetoken: '',
  eilisid: '',
  truephone: '',
  newpoint: '',
  name: '',
  points: '',
  exp: '',
  level: '',
  userpoint: '',
  hasLINE: false,
  hasFB: false,
  recommend: {
    phone: '',
    exp: ''
  }
}

export default {
  name: 'Login',
  data() {
    return {
      page1: false,
      tutorialDia: false,
      AuthToken: this.$route.params.Auth_u,
      storeid: this.$route.query.storeid,
      showWarn: false,
      validprice: false,
      checkDia: false,
      completeDia: false,
      confirmDia: false,
      doubleCheck: false,
      isUser: false,
      employee: '',
      hintText: '',
      warning: '',
      price: '',
      exchangePoints: '',
      dialogTitle: '',
      searchPhone: '',
      style: {
        default: '#666',
        red: '#f24'
      },
      // 帳號資料
      page: {
        fbid: '',
        lineid: '',
        pageName: '',
        taxID: '',
        ratio: '',
        expRatio: '',
        verCode: '',
        feedback: '',
        recommend: false,
        isrecommend: false,
        level: {
          list: [],
          type: ''
        },
        recommendData: {}
      },
      AllList: {
        ComsumeHistory: [],
        ComsumeHistory2: [],
        ExchangeHistory: [],
        ExchangeHistory2: [],
        SendHistory: [],
        SendHistory2: [],
        UndoExchange: [],
        UndoExchange2: [],
        UndoHistory: [],
        UndoHistory2: [],
        UndoSend: [],
        UndoSend2: []
      },
      recommendLoading: false,
      unabledRecommend: false,
      recommendDetail: {
        fbAuth: '',
        lineAuth: '',
        givenEX: '',
        givenPoint: '',
        recomEX: '',
        recomPoint: '',
        type: 'exp',
        recomMsg: '',
        receivedMsg: '',
        receivedData: {
          hasLINE: false,
          hasFB: false,
          phone: '',
          fbToken: '',
          lineToken: ''
        },
        recommendData: {
          usable: false,
          hasLINE: false,
          hasFB: false,
          phone: '',
          exp: '',
          fbToken: '',
          lineToken: ''
        }
      },
      // 個人資料
      user: {
        fbtoken: '',
        linetoken: '',
        eilisid: '',
        truephone: '',
        newpoint: '',
        name: '',
        points: '',
        exp: '',
        level: '',
        userpoint: '',
        hasLINE: false,
        hasFB: false,
        recommend: {
          phone: '',
          exp: ''
        }
      },
      type: ''
    };
  },
  components: {
    keyboard
  },
  mounted() {
    if (!localStorage.getItem('VERCODE')) {
      this.$router.push(`/premium`);
    }
    this.checkAccount({ Service: 'Double', Auth: this.$route.params.Auth_u })
      .then((res) => {
        if (res) {
          this.page.expRatio = res.expRatio ? res.expRatio : '';
          this.page.pageName = res.name;
          this.page.taxID = res.taxid ? res.taxid : '23055068';
          this.page.feedback = res.feedback ?  parseFloat(res.feedback) : null;
          this.page.recommend = res.recommend ? true : false;
          this.page.ratio = res.ratio ? parseInt(res.ratio) : 50;
          this.page.fbid = res.Accounts.filter(el => el.service === 'FB')[0].id;
          this.page.lineid = res.Accounts.filter(el => el.service === 'LINE')[0].id;
          // 等級
          if (res.level) {
            this.page.level.list = res.level.list;
            this.page.level.type = res.level.type;
          }
          if (res.isRecommend) {
            // this.page.recommendData = res.recommend;
            this.recommendDetail.givenEX = res.recommend.givenEX ? res.recommend.givenEX : '';
            this.recommendDetail.recomEX = res.recommend.recomEX ? res.recommend.recomEX : '';
            this.recommendDetail.givenPoint = res.recommend.givenPoint ? res.recommend.givenPoint : '';
            this.recommendDetail.recomPoint = res.recommend.recomPoint ? res.recommend.recomPoint : '';
            this.recommendDetail.type = res.recommend.type;
            this.recommendDetail.fbAuth = res.Accounts.filter(el => el.service === 'FB')[0].id;
            this.recommendDetail.lineAuth = res.Accounts.filter(el => el.service === 'LINE')[0].id;
            this.recommendDetail.receivedMsg = res.recommend.receivedMsg;
            this.recommendDetail.recomMsg = res.recommend.recomMsg;
          }
        }
      });
  },
  computed: {
    UncodedPhone() {
      let usableCode = this.user.eilisid.slice(2, 12).toString();
      return usableCode
        .replace(/a/g, '0')
        .replace(/b/g, '1')
        .replace(/c/g, '2')
        .replace(/d/g, '3')
        .replace(/e/g, '4')
        .replace(/f/g, '5')
        .replace(/g/g, '6')
        .replace(/h/g, '7')
        .replace(/i/g, '8')
        .replace(/j/g, '9');
    }
  },
  methods: {
    ...mapActions({
      getPoints           : 'getPoints',
      getUserByPhoneNum   : 'getUserByPhone',
      sendSheet           : 'sendSheet',
      checkAccount        : 'checkAccount',
      comsumeBroadcast    : 'comsumeBroadcast',
      getSuccessMessage   : 'getSuccessMessage',
      getStoreData        : 'getStoreData',
      setHistory          : 'setHistory',
      refreshPoint        : 'refreshPoint',
      reverseComsume      : 'reverseComsume',
      refreshPointBeta    : 'refreshPointBeta',
      exchangePointBeta   : 'exchangePointBeta',
      getAllHistory       : 'getAllHistory'
    }),
    gotoHistory() {
      this.$router.push(`/premhistory/${this.AuthToken}?storeid=${this.storeid}`);
    },
    showTutorial() {
      this.tutorialDia = true;
    },
    getLevel(exp) {
      const levelList = this.page.level.list;
      if (levelList && levelList.length > 0) {
        const expList = levelList.map(el => parseInt(el.exp)).sort((a, b) => a - b);
        for (let i = 0; i < expList.length; i += 1) {
          const index = i;
          if (exp < expList[0]) {
            this.user.level = 'none';
            return;
          }
          if (expList[index] <= exp && exp < expList[index + 1]) {
            this.user.level = levelList.filter(st => st.exp === expList[index])[0].title;
            return;
          }
          if ((index === expList.length - 1) && expList[index] <= exp) {
            this.user.level = levelList.filter(st => st.exp === expList[index])[0].title;
            return;
          }
        }
      }
      else {
        this.user.level = 'none';
      }
    },
    // 取得用戶資訊用電話
    getUserByPhone(phone) {
      this.user = { fbtoken: '', linetoken: '', eilisid: '', truephone: '', newpoint: '', points: '', userpoint: '', hasLINE: false, hasFB: false };
      const validPhone = phone.trim();
      this.getUserByPhoneNum({ service: 'LINE', auth: this.page.lineid, phone: validPhone })
        .then((res) => {
          if (res.Message) {
            this.user.hasLINE = false;
            this.user.linetoken = '';
            this.getUserByPhoneNum({ service: 'FB', auth: this.page.fbid, phone: validPhone })
              .then((resp) => {
                if (!resp.Message) {
                  this.user.hasFB = true;
                  this.user.fbtoken = resp.id;
                  this.user.points = resp.Point ? resp.Point : 0;
                  this.user.name = resp.Name;
                  this.user.exp = resp.EXP;
                  this.getLevel(resp.EXP);
                }
                else {
                  this.user = JSON.parse(JSON.stringify(defaultUser));
                }
              });
          }
          else {
            this.user.hasLINE = true;
            this.user.linetoken = res.id;
            this.user.points = res.Point;
            this.user.name = res.Name;
            this.user.exp = res.EXP;
            this.getLevel(res.EXP);
            this.getUserByPhoneNum({ service: 'FB', auth: this.page.fbid, phone: validPhone })
              .then((resp) => {
                if (!resp.Message) {
                  this.user.hasFB = true;
                  this.user.fbtoken = resp.id;
                }
                else {
                  this.user.hasFB = false;
                  this.user.fbtoken = '';
                }
              });
          }
        })
    },
    getRecommend() {
      const apiUrl = 'https://member-card.herokuapp.com/getRecommendUser';
      const postData = {
        fbAuth: this.recommendDetail.fbAuth,
        lineAuth: this.recommendDetail.lineAuth,
        receivedPhone: this.user.truephone.trim(),
        recommendPhone: this.recommendDetail.recommendData.phone
      };
      if (this.recommendDetail.recommendData.phone === this.user.truephone.trim()) {
        this.unabledRecommend = true;
        this.recommendDetail.recommendData.usable = false;
        this.recommendDetail.recommendData.exp = '';
      }
      else {
        this.recommendLoading = true;
        this.axios.post(apiUrl, postData).then((res) => {
          this.recommendLoading = false;
          if (res) {
            if (res.data.Message) {
              this.unabledRecommend = true;
              this.recommendDetail.recommendData.usable = false;
              this.recommendDetail.recommendData.exp = '';
            }
            else {
              this.unabledRecommend = false;
              this.recommendDetail.recommendData.usable = true;
              this.recommendDetail.recommendData.exp = res.data.EXP;
              this.recommendDetail.recommendData.hasFB = res.data.hasFB;
              this.recommendDetail.recommendData.hasLINE = res.data.hasLINE;
              this.recommendDetail.recommendData.fbToken = res.data.FBToken ? res.data.FBToken : '';
              this.recommendDetail.recommendData.lineToken = res.data.LINEToken ? res.data.LINEToken : '';
            }
          }
          else {
            this.unabledRecommend = true;
            this.recommendDetail.recommendData.usable = false;
            this.recommendDetail.recommendData.exp = '';
          }
        });
      }
    },
    // 取得用戶資訊
    getValue() {
      this.isUser = false;
      if (this.user.eilisid) {
        if (this.UncodedPhone[0] && this.UncodedPhone[0].toString() !== '0') {
          this.user.truephone = `0${this.UncodedPhone}`.substr(0, 10);
        }
        else {
          this.user.truephone = this.UncodedPhone;
        }
      }
      this.user.eilisid = '';
      const validPhone = this.user.truephone.trim();
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      this.getUserByPhoneNum({ service: 'LINE', auth: this.page.lineid, phone: validPhone })
        .then((res) => {
          if (res.Message) {
            this.user.hasLINE = false;
            this.user.linetoken = '';
            this.getUserByPhoneNum({ service: 'FB', auth: this.page.fbid, phone: validPhone })
              .then((resp) => {
                if (resp.Message) {
                  this.user = JSON.parse(JSON.stringify(defaultUser));
                  this.showWarn = true;
                  this.warning = resp.Message;
                }
                else {
                  this.isUser = true;
                  this.recommendDetail.receivedData.phone = validPhone;
                  this.user.hasFB = true;
                  this.recommendDetail.receivedData.hasFB = true;
                  this.showWarn = false;
                  this.user.points = resp.Point ? resp.Point : 0;
                  this.user.name = resp.Name;
                  this.user.exp = resp.EXP;
                  this.user.fbtoken = resp.id;
                  this.recommendDetail.receivedData.fbToken = resp.id;
                  this.getLevel(resp.EXP);
                }
              });
          }
          else {
            this.isUser = true;
            this.showWarn = false;
            this.user.hasLINE = true;
            this.recommendDetail.receivedData.hasLINE = true;
            this.recommendDetail.receivedData.phone = validPhone;
            this.user.linetoken = res.id;
            this.user.name = res.Name;
            this.user.exp = res.EXP;
            this.recommendDetail.receivedData.lineToken = res.id;
            this.user.points = res.Point ? res.Point : 0;
            this.getLevel(res.EXP);
            this.getUserByPhoneNum({ service: 'FB', auth: this.page.fbid, phone: validPhone })
              .then((resp) => {
                if (!resp.Message) {
                  this.user.hasFB = true;
                  this.recommendDetail.receivedData.hasFB = true;
                  this.user.fbtoken = resp.id;
                  this.recommendDetail.receivedData.fbToken = resp.id;
                }
                else {
                  this.user.hasFB = false;
                  this.recommendDetail.receivedData.hasFB = false;
                  this.user.fbtoken = '';
                  this.recommendDetail.receivedData.fbToken = '';
                }
              })
          }
          loading.close();
          this.type = 'price';
        })
    },
    // 輸入
    inputNumber(num) {
      if (this.type === 'phone') { this.user.truephone += num } 
      else if (this.type === 'price') { this.price += num }
      else if (this.type === 'point' || this.type === 'send') { this.exchangePoints += num }
      else if (this.type === 'vercode') { this.page.verCode += num }
      else if (this.type === 'employee') { this.employee += num }
      else { this.user.eilisid += num }
    },
    // 兌換點數看這邊
    checkPoint(val) {
      this.confirmDia = true;
      this.type = val;
      if (val === 'point') {
        this.dialogTitle = 'Store.redeem';
      }
      else if (val === 'send') {
        this.dialogTitle = 'Store.topup';
      }
    },
    logout() {
      this.$router.push(`/Premium`);
    },
    getComsume() {
      const FBList = {};
      const LINEList = {};
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      const typeList = ['ComsumeHistory', 'ExchangeHistory', 'SendHistory', 'UndoExchange', 'UndoHistory', 'UndoSend', 'last'];
      this.page1 = true;
      for (let i = 0; i < typeList.length; i += 1) {
        const position = i
        const type = typeList[position];
        this.getAllHistory({ service: 'FB', auth: this.page.fbid, store: this.storeid ? this.storeid : 'NoName', path: type })
          .then((res) => {
            FBList[type] = res ? res.filter(el => el[1].Service) : [];
            this.getAllHistory({ service: 'LINE', auth: this.page.lineid, store: this.storeid ? this.storeid : 'NoName', path: type })
              .then((resp) => {
                LINEList[type] = resp ? resp.filter(el => el[1].Service) : [];
                // 整合記錄
                this.AllList[type] = LINEList[type].concat(FBList[type]).sort((a, b) => b[1].Time - a[1].Time);
                this.AllList[`${type}2`] = LINEList[type].concat(FBList[type]).sort((a, b) => b[1].Time - a[1].Time);
                if (position === typeList.length - 2) {
                  loading.close();
                }
              });
          });
      }
    },
    clear() {
      if (this.type === 'phone') { this.user.truephone = '' }
      else if (this.type === 'price') { this.price = '' }
      else if (this.type === 'point' || this.type === 'send') { this.exchangePoints = '' }
      // else if (this.type === 'history') { this.searchPhone = '' }
      else if (this.type === 'vercode') { this.page.verCode = '' }
      else if (this.type === 'employee') { this.employee = '' }
      else { this.user.eilisid = '' }
    },
    checksend() {
      if (this.price <= 0) {
        this.validprice = true;
        return;
      }
      this.checkDia = true;
    },
    getFocus(val) {
      this.type = val;
    },
    sendExchange() {
      if (this.type === 'point') {
        if (this.user.points >= this.exchangePoints) {
          this.checkPush();
          this.hintText = '';
        }
        else { this.hintText = 'Store.notEnough' }
      }
      else {
        this.hintText = '';
        this.checkPush();
      }
    },
    sendMessageReward(service, auth, token, newPoints, rewardPoint) {
      const reward = Math.floor(rewardPoint);
      this.getSuccessMessage({ service: service, auth: auth, type: (this.type === 'point') ? 'Exchange' : 'Send' })
        .then((msg) => {
          const successResponse = msg.replace(/@ELS_CHARGE/g, this.exchangePoints).replace(/@ELS_REMAIN/g, newPoints.toString()).replace(/@ELS_RESTPOINT/g, newPoints.toString()).replace(/@ELS_REWARD/g, reward.toString());
          if (successResponse && successResponse !== 'null') {
            this.comsumeBroadcast({ service, auth, token, message: successResponse })
              .then(() => {
                this.exchangePoints = '';
              })
          }
        })
    },
    sendMessage(service, auth, token, newPoints) {
      this.getSuccessMessage({ service: service, auth: auth, type: (this.type === 'point') ? 'Exchange' : 'Send' })
        .then((msg) => {
          const successResponse = msg.replace(/@ELS_CHARGE/g, this.exchangePoints).replace(/@ELS_REMAIN/g, newPoints.toString()).replace(/@ELS_RESTPOINT/g, newPoints.toString());
          if (successResponse && successResponse !== 'null') {
            this.comsumeBroadcast({ service, auth, token, message: successResponse })
              .then(() => {
                this.exchangePoints = '';
              })
          }
        })
    },
    checkPush() {
      // 待辦 8.14
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      this.doubleCheck = false;
      this.confirmDia = false;
      const validPoints = parseInt(this.exchangePoints);
      let newPoints = 0;
      // 兌換點數
      if (this.type === 'point') {
        if (this.page.feedback && this.page.feedback !== '') {
          const rewardPoint = validPoints * this.page.feedback;
          const finalPoint = validPoints - Math.floor(rewardPoint);
          newPoints = parseInt(this.user.points) - finalPoint;
          // 判斷帳號
          if (this.user.hasFB) {
            this.exchangePointBeta({ service: 'FB', auth: this.page.fbid, token: this.user.fbtoken, point: finalPoint, store: this.storeid })
              .then((res) => {
                this.getValue();
                loading.close();
                this.sendMessageReward('FB', this.page.fbid, this.user.fbtoken, newPoints, rewardPoint);
                // 如果同時有 LINE
                if (this.user.hasLINE) {
                  const time = Date.now();
                  const storedetail = { Phone: this.user.truephone, Point: finalPoint, Time: time };
                  const userdetail = { Point: finalPoint * -1, Time: time, Store: this.storeid };
                  this.setHistory({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, key: res.data.Key, store: this.storeid, type: 'Exchange', storedetail: storedetail, userdetail: userdetail });
                }
                this.completeDia = true;
                this.user.newpoint = newPoints;
              });
          }
          else {
            this.exchangePointBeta({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, point: finalPoint, store: this.storeid })
              .then((res) => {
                this.getValue();
                loading.close();
                this.sendMessageReward('LINE', this.page.lineid, this.user.linetoken, newPoints, rewardPoint);
                this.completeDia = true;
                this.user.newpoint = newPoints;
              });
          }
        }
        else {
          newPoints = parseInt(this.user.points) - validPoints;
          if (this.user.hasFB) {
            this.exchangePointBeta({ service: 'FB', auth: this.page.fbid, token: this.user.fbtoken, point: validPoints, store: this.storeid })
              .then((res) => {
                this.getValue();
                loading.close();
                this.sendMessage('FB', this.page.fbid, this.user.fbtoken, newPoints);
                // 如果同時有LINE帳號
                if (this.user.hasLINE) {
                  const time = Date.now();
                  const storedetail = { Phone: this.user.truephone, Point: validPoints, Time: time };
                  const userdetail = { Point: validPoints * -1, Time: time, Store: this.storeid };
                  this.setHistory({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, key: res.data.Key, store: this.storeid, type: 'Exchange', storedetail: storedetail, userdetail: userdetail });
                }
                this.completeDia = true;
                this.user.newpoint = newPoints;
              })
          }
          else {
            this.exchangePointBeta({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, point: validPoints, store: this.storeid })
              .then((res) => {
                this.getValue();
                loading.close();
                this.sendMessage('LINE', this.page.lineid, this.user.linetoken, newPoints);
                this.completeDia = true;
                this.user.newpoint = newPoints;
              })
          }
        }
        
      }
      // 非兌換點數
      else {
        newPoints = parseInt(this.user.points) + validPoints;
        if (this.user.hasFB) {
          this.refreshPointBeta({ phone: this.user.truephone, service: 'FB', auth: this.page.fbid, token: this.user.fbtoken, points: validPoints, store: this.storeid })
            .then((res) => {
              this.getValue();
              loading.close();
              this.sendMessage('FB', this.page.fbid, this.user.fbtoken, newPoints);
              // 如果同時有LINE帳號
              if (this.user.hasLINE) {
                const time = Date.now();
                const storedetail = { Phone: this.user.truephone, Point: validPoints, Time: time };
                const userdetail = { Point: validPoints, Time: time, Store: this.storeid };
                this.setHistory({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, key: res.data.Key, store: this.storeid, type: 'Send', storedetail: storedetail, userdetail: userdetail });
              }
              this.completeDia = true;
              this.user.newpoint = newPoints;
            })
        }
        else {
          this.refreshPointBeta({ phone: this.user.truephone, service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, points: validPoints, store: this.storeid })
            .then((res) => {
              this.getValue();
              loading.close();
              this.sendMessage('LINE', this.page.lineid, this.user.linetoken, newPoints);
              this.completeDia = true;
              this.user.newpoint = newPoints;
            })
        }
      }
    },
    sendRecommend() {
      const apiUrl = 'https://member-card.herokuapp.com/receivedRecommend';
      this.axios.post(apiUrl, this.recommendDetail).then((res) => {
        this.recommendDetail.recommendData.phone = '';
      });
    },
    checkComsume() {
      this.checkDia = false;
      if (this.page.isrecommend) {
        if (this.recommendDetail.recommendData.phone !== '' && this.recommendDetail.recommendData.usable) {
          this.unabledRecommend = false;
          this.sendRecommend();
          this.sendComsume();
        }
        else {
          this.unabledRecommend = true;
        }
      }
      else {
        this.sendComsume();
      }
    },
    sendComsume() {
      // 如果有臉書優先用臉書廣播
      if (this.user.hasFB) {
        if (!this.user.fbtoken || this.user.fbtoken === '') {
          this.showWarn = true;
          this.warning = '無效的用戶 ID，請確定輸入電話後有點擊"查詢"按鈕';
          return;
        }
        const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        // 點入換算
        const realPrice = parseInt(this.price);
        const realratio = parseInt(this.page.ratio);
        const receivedPoints = Math.floor(realPrice / realratio);
        const receivedExps = (this.page.expRatio && this.page.expRatio !== '') ? Math.floor(realPrice * this.page.expRatio) : '';
        const newPoints = receivedPoints + parseInt(this.user.points);
        this.getSuccessMessage({ service: 'FB', auth: this.page.fbid, type: 'Comsume' })
          .then((msg) => {
            const successResponse = msg.replace(/@ELS_ACC_POINT/g, newPoints).replace(/@ELS_ACC_EXP/g, receivedExps);
            this.refreshPointBeta({ phone: this.user.truephone, service: 'FB', auth: this.page.fbid, token: this.user.fbtoken, points: receivedPoints, price: this.price, store: this.storeid, exp: receivedExps })
              .then((res) => {
                this.getValue();
                loading.close();
                if (res.data.Error) {
                  this.showWarn = true;
                  this.warning = '無效的用戶 ID，請確定輸入電話後有點擊"查詢"按鈕';
                }
                else {
                  if (this.user.hasLINE) {
                    const time = Date.now();
                    const storedetail = { Phone: this.user.truephone, Price: this.price, Time: time };
                    const userdetail = { Price: this.price, Time: time, Store: this.storeid };
                    this.setHistory({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, key: res.data.Key, store: this.storeid, type: 'Comsume', storedetail: storedetail, userdetail: userdetail });
                  }
                  this.comsumeBroadcast({ service: 'FB', auth: this.page.fbid, token: this.user.fbtoken, message: successResponse });
                  this.completeDia = true;
                  this.user.newpoint = newPoints;
                }
              })
          });
      }
      // 沒有臉書才用LINE廣播
      else {
        if (!this.user.linetoken || this.user.linetoken === '') {
          this.showWarn = true;
          this.warning = '無效的用戶 ID，請確定輸入電話後有點擊"查詢"按鈕';
          return;
        }
        const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        // 點入換算
        const realPrice = parseInt(this.price);
        const realratio = parseInt(this.page.ratio);
        const receivedPoints = Math.floor(realPrice / realratio);
        const receivedExps = (this.page.expRatio && this.page.expRatio !== '') ? Math.floor(realPrice * this.page.expRatio) : null;
        const newPoints = receivedPoints + parseInt(this.user.points);
        this.getSuccessMessage({ service: 'LINE', auth: this.page.lineid, type: 'Comsume' })
          .then((msg) => {
            const successResponse = msg.replace(/@ELS_ACC_POINT/g, newPoints).replace(/@ELS_ACC_EXP/g, receivedExps);
            this.refreshPointBeta({ phone: this.user.truephone, service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, points: receivedPoints, price: this.price, store: this.storeid, exp: receivedExps })
              .then((res) => {
                this.getValue();
                loading.close();
                if (res.data.Error) {
                  this.showWarn = true;
                  this.warning = '無效的用戶 ID，請確定輸入電話後有點擊"查詢"按鈕';
                }
                this.comsumeBroadcast({ service: 'LINE', auth: this.page.lineid, token: this.user.linetoken, message: successResponse });
                this.completeDia = true;
                this.user.newpoint = newPoints;
              })
          });
      }
    }
  },
  watch: {
    searchPhone(val) {
      this.AllList.ComsumeHistory2 = this.AllList.ComsumeHistory.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.AllList.SendHistory2 = this.AllList.SendHistory.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.AllList.ExchangeHistory2 = this.AllList.ExchangeHistory.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.AllList.UndoHistory2 = this.AllList.UndoHistory.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.AllList.UndoSend2 = this.AllList.UndoSend.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
      this.AllList.UndoExchange2 = this.AllList.UndoExchange.filter(el => el[1].Phone && el[1].Phone.indexOf(val) !== -1);
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Poppins');
  .sendButton {
    background-color: #67c23a !important;
    color: #fff !important;
    border-radius: 0 3px 3px 0 !important;
    border: none !important;
  }
  .simple-keyboard {
    margin: 10px auto;
  }
  .sendButton:hover {
    opacity: 0.8;
  }
  .el-input {
    margin-bottom: 25px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    padding: 0;
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #666;
  }
  .bg-purple {
    background: #777;
  }
  .bg-purple-light {
    background: #fff;
    border: 1px solid;
  }
  .recommend {
    margin-top: 15px;
  }
  .grid-content {
    margin: 0 auto;
    border-radius: 4px;
    min-height: 36px;
    width: 630px;
    padding: 20px 20px 10px 20px;
    margin-bottom: 10px;
    text-align: left;
  }
  .web {
    text-decoration: none;
    color: black;
    transition: 0.2s;
  }
  .web:hover {
    color: #f24;
  }
  .simple-keyboard {
    max-width: 850px;
  }
</style>